import {GET_MASSAGE,SET_UNREAD} from '../data/massage_data';
import {DELETE_NOF} from '../store/actions';
const initalState = {
massages:[],
unreadTotal: 0
}
export default (state=initalState,actions) =>{
  switch (actions.type) {

    case GET_MASSAGE:
    return{
      ...state,massages:actions.data

    }
    case SET_UNREAD:
    return{
      ...state, unreadTotal: actions.total || 0
    }
    case DELETE_NOF:
    return{
      ...state,
       massages:state.massages.filter(prod => prod.id !== actions.id)

    }


  }
  return state;
}
